import { ArrowLeft } from "react-feather"
import { useNavigate } from "react-router-dom"
import { roomApi } from "@/api/client/room"
import { IconButton } from "@/components/ui/icon-button/icon-button"

interface RoomHeaderProps {
  /**
   * 部屋ID
   */
  roomId: number
}

/**
 * 部屋詳細画面で使用するヘッダーコンポーネント
 * 戻るボタンと部屋名を表示
 * 部屋情報はAPIから自動で取得され、戻るボタンで部屋詳細ページに遷移
 */
export function RoomHeader({ roomId }: RoomHeaderProps) {
  const navigate = useNavigate()

  const { data: roomResponse } = roomApi.useRoomGet(
    roomId,
    { withProperty: "true" },
    {
      query: {
        enabled: !!roomId,
      },
    }
  )

  const room = roomResponse?.room
  const property = room?.property

  const handleBack = () => {
    if (property?.id) {
      navigate(`/properties/${property.id}/rooms/${roomId}`)
    }
  }

  return (
    <div className="flex items-center gap-2.5">
      <IconButton variant="outline" size="back" onClick={handleBack}>
        <ArrowLeft className="h-4 w-4 text-primary" />
      </IconButton>
      <h1 className="text-base font-semibold text-primary truncate">
        部屋：{room?.name ? `${room.name}` : "読み込み中..."}
      </h1>
    </div>
  )
}
